
import { defineComponent, ref, inject, reactive,computed, toRefs, onMounted } from "vue";
import Swal from 'sweetalert2'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { Modal } from 'ant-design-vue';

interface FormState {
  id: string;
  message: string;
}

const initialState = {
  id:"",
  message: ""
};

export default defineComponent({
   props: {
    title: {
      type: String,
      default: "Form",
    },
    data: {
      type: Object,
    },
    isNew: {
      type: Boolean,
      default: true,
    },
    prop_errors_obj: {
     type: Object,
    },
  },
  setup(props) {
    /* DATA */
    const store = useStore()
    const form = reactive<FormState>({...initialState})
    const visible = ref(false);
    const form_action = ref('save');
    const invoice = inject<any>('invoice');
    const edit = (record: any) => {
      const {
        id,
        message
      } = toRefs(form)
      id.value = record.id
      message.value = record.message
     
      visible.value = true
      form_action.value = 'update'
    }

    const save = () => {
      visible.value = false
      store.dispatch("InvoiceQueryVendor/update",form).then((res:any) => {
            store.dispatch('VendorInvoice/show',invoice.id).then((res:any) => {
                invoice.invoice_queries = res.data.invoice_queries
            })
        })
    }
    return {
      form,
      form_action,
      visible,
      invoice,
      edit,
      save
    };
  },
});
